module.exports = __webpack_public_path__ + "img/lr.65a51b01.svg";